import './point-of-sale-create-delivery/point-of-sale-create-delivery.component';
import './point-of-sale-create-delivery/point-of-sale-create-delivery.scss';
